<script>
    import axios from 'axios';
    import MultipleSelector from '@/components/Form/MultipleSelector.vue'

    export default {
        name : 'user-country-selector',
        extends: MultipleSelector,
        methods: {
            buildOptions: function (countries) {
                let options = [];
                for (let key in countries) {
                    let option = {};
                    option['id'] = countries[key]['iso_code_3'];
                    option['name'] = countries[key]['name'];
                    options.push(option);
                }
                return options;
            },
            initCountries () {
                axios
                    .get('https://res.hotelkey.com/reservas/mvc.php/product_decision_scr_templates_web_json/GeoCountries/list')
                    .then(response => {
                        if (response.data.result) {
                            this.options = this.buildOptions(response.data.data);
                        } else {
                            this.emitError();
                        }
                    }).catch(error => {
                        this.emitError();
                    })
            },
            emitError () {
                this.$emit('error', "Se ha producido un error al consultar los paises.");
            }
        },
        created () {
            this.initCountries ();
        }
    }
</script>